import { usePageContext } from "vike-react/usePageContext"
import NavbarDesktop from "./NavbarDesktop"
import NavbarMobile from "./NavbarMobile"

function Navbar() {
  const pageContext = usePageContext()
  const currentPath = pageContext?.currentPath || pageContext?.urlPathname || (typeof window !== 'undefined' ? window.location.pathname : '/')

  // Hidden on admin and on the /v/ capture viewer (chromeless share page).
  const shouldHide = ['/admin', '/v/', '/app-signin'].some((prefix) =>
    currentPath?.startsWith(prefix) ||
    (typeof window !== 'undefined' && window.location.pathname.startsWith(prefix))
  )

  if (shouldHide) return null

  return (
    <>
      <div className="hidden lg:block">
        <NavbarDesktop />
      </div>

      <div className="lg:hidden">
        <NavbarMobile />
      </div>
    </>
  )
}

// AldooComponent definition for auto-discovery
export const AldooComponent = {
  id: "Navbar",
  component: Navbar,
  description: "Main navigation bar with logo, menu items, CTA button and account icon. Auto-hides on admin routes.",
  input: {},
}

export default Navbar
